import { render } from "./LoginAgent.vue?vue&type=template&id=58e5845a&scoped=true"
import script from "./LoginAgent.vue?vue&type=script&lang=js"
export * from "./LoginAgent.vue?vue&type=script&lang=js"

import "./LoginAgent.vue?vue&type=style&index=0&id=58e5845a&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e5845a"]])

export default __exports__